module.exports = __webpack_public_path__ + "images/intersection-icon.d2b89582bc9651e995239387f93bfddf.png";